import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  NgZone,
  HostListener,
  AfterViewInit,
  Renderer2,
  ElementRef,
  ViewChild,
  QueryList,
  ViewChildren,
  ChangeDetectorRef,
} from "@angular/core";
import { QuestionList } from "../../shared/models/bank-question-list.model";
import { ShareDataService } from "../../shared/services/shared.service";
import { CdkAccordionItem } from "@angular/cdk/accordion";

@Component({
    selector: "app-filter-test-category",
    templateUrl: "./filter-test-category.component.html",
    styleUrls: ["./filter-test-category.component.scss"],
    standalone: false
})
export class FilterTestCategoryComponent implements OnInit, AfterViewInit {
  qCheckBoxCount: any = 0;
  selectAllItems = true;
  count: any = 0;
  status = true;
  mainPanelElements: any;
  selectedRow: number;
  mainPanel: any;
  questionPanel: any;
  catInputs: any;
  quesChckbxes: any;
  catCountBxes: any;
  catCheckboxes: any;
  inputQuesCount: any;
  filterJsonObject: any = { questions: [], cats: [] };
  dataList: any[] = [];
  isFilterOpen: boolean = false;
  private triggerElement: HTMLElement | null = null;
  questionTypeCheckedMap = new Map<string, boolean>();
  categoryCountMap: Map<number, number> = new Map();

  @ViewChildren("items") items: QueryList<ElementRef>;
  @ViewChildren("inputCat") inputCats: QueryList<ElementRef>;
  @ViewChildren("qCheckbox") qCheckboxes: QueryList<ElementRef>;
  @ViewChildren("catCount") catCounts: QueryList<ElementRef>;
  @ViewChildren("cCheckbox") cCheckboxes: QueryList<ElementRef>;
  @ViewChild("mainPanel", { static: true }) mainPanels: ElementRef;
  @ViewChild("questionPanel", { static: true }) questionPanels: ElementRef;
  @ViewChild("inputQues", { static: true }) inputQues: ElementRef;
  @ViewChild("closeButton", { static: true }) closeButton: ElementRef;
  @ViewChild('selectButton') selectButton: ElementRef;
  @ViewChild('deselectButton') deselectButton: ElementRef;
  @ViewChildren('selectCategoryButton') selectCategoryButton: QueryList<ElementRef>;
  @ViewChildren('deselectCategoryButton') deselectCategoryButton: QueryList<ElementRef>;
  @ViewChildren(CdkAccordionItem) accordionItems: QueryList<CdkAccordionItem>;
  @Output() countChangeEvent = new EventEmitter<number>();
  @ViewChild("filterAnnouncementRegion") public filterAnnouncementRegion: ElementRef;

  constructor(
    private elem: ElementRef,
    private render: Renderer2,
    private sharedService: ShareDataService,
    private cdr: ChangeDetectorRef
  ) {}

  @Input("question-list") questionList: QuestionList;
  @Output() messageEvent = new EventEmitter<any>();
  @Output() filterEvent = new EventEmitter<any>();

  ngAfterViewInit() {
    this.mainPanelElements = this.items;
    this.catInputs = this.inputCats;
    this.quesChckbxes = this.qCheckboxes;
    this.catCountBxes = this.catCounts;
    this.catCheckboxes = this.cCheckboxes;
    this.mainPanel = this.mainPanels;
    this.questionPanel = this.questionPanels;
    this.inputQuesCount = this.inputQues;
  }

  ngOnInit() {}

  accordionKeyHandler(event: KeyboardEvent, accordionItem: CdkAccordionItem, question?) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleQuestionCheckboxStates(question);
      accordionItem.toggle();
    }
  }

  handleQuestionCheckboxStates(question) {
    if (question && question.tags) {
      let checkedCount = 0;
      question.tags.forEach((questionValue) => {
        questionValue.checked = this.filterJsonObject.cats.some(cat => cat.val === questionValue.id);
        if (questionValue.checked) {
          checkedCount++;
        }
      });
      const categoryIndex = this.questionList.itemInfo.categories.findIndex(cat => cat.name === question.name);
      
      if (categoryIndex !== -1) {
        this.cdr.detectChanges();
        const selectBtn = this.elem.nativeElement.querySelector("#select" + categoryIndex);
        const deselectBtn = this.elem.nativeElement.querySelector("#deselect" + categoryIndex);
        
        if (selectBtn && deselectBtn) {
          // Check if ALL items in this category are checked
          if (checkedCount === question.tags.length && checkedCount > 0) {
            this.toggleShowHide(false, selectBtn, deselectBtn);
          } else {
            this.toggleShowHide(true, selectBtn, deselectBtn);
          }
        }
      }
    }
    this.handleNonObjectQuestionCheckboxStates();
  }

  private handleNonObjectQuestionCheckboxStates() {
    if (this.questionList?.itemInfo?.typesAvailable) {
      this.questionList.itemInfo.typesAvailable.forEach(q => {
        const isChecked = this.filterJsonObject.questions.includes(q);
        this.questionTypeCheckedMap.set(String(q), isChecked);
      });
      this.qCheckBoxCount = this.filterJsonObject.questions.length;
      // Update select/deselect all button state for question type
      if (this.questionList.itemInfo.typesAvailable.length === this.qCheckBoxCount) {
        this.selectAllItems = false;
      } else {
        this.selectAllItems = true;
      }
    }
  }

  openMainPanel(triggerElement?, question?) {
    this.handleQuestionCheckboxStates(question);
    this.triggerElement = triggerElement;
    this.isFilterOpen = true;
    if ( this.sharedService.getCategoryFilterCount()?.length > 0 ) {
      for (let i = 0; i < this.catCountBxes.length; i++) {
        for (let key of this.sharedService.getCategoryFilterCount()) {
          if (
            this.catCountBxes._results[i].nativeElement.parentElement
              .firstChild.wholeText === key.name
          ) {
            this.catCountBxes._results[i].nativeElement.innerHTML = key.value;
            this.catInputs._results[i].nativeElement.value = key.value;
          }
        }
      }
    }
    
    this.toggleDisplay(this.mainPanel.nativeElement.classList, true);
    if (this.closeButton && this.closeButton.nativeElement) {
      this.closeButton.nativeElement.focus();
    }
  }

  clickCount(event, section, index) {
    if (section == "question") {
      this.qCheckBoxCount = this.qCheckBoxCount;
      if (event.target.checked) {
        this.qCheckBoxCount = this.qCheckBoxCount + 1;
      } else {
        this.qCheckBoxCount = this.qCheckBoxCount - 1;
      }

      if (this.quesChckbxes.length == this.qCheckBoxCount) {
        this.selectAllItems = false;
      } else {
        this.selectAllItems = true;
      }
    } else if (section == "category") {
      const counyShowBox: any = this.catCountBxes._results[index].nativeElement;
      const inputCatCount: any = this.catInputs._results[index].nativeElement;

      if (event.target.checked) {
        inputCatCount.value = parseInt(inputCatCount.value, 10) + 1;
      } else {
        inputCatCount.value = parseInt(inputCatCount.value, 10) - 1;
      }
      counyShowBox.innerHTML = inputCatCount.value;
      this.categoryCountMap.set(index, inputCatCount.value);

      const elements: any = this.elem.nativeElement.querySelectorAll(
        ".cCheckbox" + index
      );
      const selectAll = this.elem.nativeElement.querySelector(
        "#select" + index
      );
      const deSelectAll = this.elem.nativeElement.querySelector(
        "#deselect" + index
      );

      if (elements.length == inputCatCount.value) {
        this.toggleShowHide(false, selectAll, deSelectAll);
      } else {
        this.toggleShowHide(true, selectAll, deSelectAll);
      }
    }
  }

  closeFilter(section) {
    // Close all accordion items when closing the filter
    if (this.accordionItems) {
      this.accordionItems.forEach(item => {
        if (item.expanded) {
          item.close();
        }
      });
    }
    this.isFilterOpen = false;
    if (section == "mainPanel") {
      this.count = 0;
      this.dataList.length = 0;
      this.toggleDisplay(this.mainPanel.nativeElement.classList, false);
      this.catInputs.forEach((element) => {
        this.dataList.push(element.nativeElement.value);
        this.count = parseInt(element.nativeElement.value, 10) + this.count;
      });
      this.count = this.count + parseInt(this.qCheckBoxCount, 10);
      let countArray = [];
      for (
        let index = 0;
        index < this.questionList.itemInfo.categories.length;
        index++
      ) {
        countArray.push({
          name: " " + this.questionList.itemInfo.categories[index].name + " ",
          value: this.dataList[index],
        });
      }
      //this.sharedService.setCategoryFilterCount(countArray);
      this.messageEvent.emit(this.count);
      if (this.triggerElement) {
        this.triggerElement.focus();
        this.triggerElement = null;
      }
    }
  }

  selectAll(section, index, catName) {
    if (section == "question") {
      this.selectAllItems = false;
      this.qCheckBoxCount = 0;
      this.quesChckbxes.forEach((element) => {
        element.nativeElement.checked = true;
      });
      this.qCheckBoxCount = this.quesChckbxes.length;
      this.createFilterJsonObject(this.quesChckbxes, "question", true, catName);
    } else if (section == "category") {
      const selectAll = this.elem.nativeElement.querySelector(
        "#select" + index
      );
      const deSelectAll = this.elem.nativeElement.querySelector(
        "#deselect" + index
      );
      this.toggleShowHide(false, selectAll, deSelectAll);

      const elements = this.elem.nativeElement.querySelectorAll(
        ".cCheckbox" + index
      );
      const counyShowBox: any = this.elem.nativeElement.querySelector(
        "#catCount" + index
      );
      const inputCatCount: any = this.elem.nativeElement.querySelector(
        "#inputCat" + index
      );

      elements.forEach((element) => {
        element.checked = true;
      });

      inputCatCount.value = elements.length;
      counyShowBox.innerHTML = elements.length;
      this.categoryCountMap.set(index, elements.length);
      this.createFilterJsonObject(elements, "category", true, catName);

      this.cdr.detectChanges();
      const deselectBtn = deSelectAll.querySelector('button');
      if (deselectBtn) {
        deselectBtn.focus();
      }
    }
  }

  deselectAll(section, index, catName) {
    if (section == "question") {
      this.selectAllItems = true;
      this.qCheckBoxCount = 0;
      this.quesChckbxes.forEach((element) => {
        element.nativeElement.checked = false;
      });
      this.createFilterJsonObject(
        this.quesChckbxes,
        "question",
        false,
        catName
      );
    } else if (section == "category") {
      const selectAll = this.elem.nativeElement.querySelector(
        "#select" + index
      );
      const deSelectAll = this.elem.nativeElement.querySelector(
        "#deselect" + index
      );
      this.toggleShowHide(true, selectAll, deSelectAll);

      const elements = this.elem.nativeElement.querySelectorAll(
        ".cCheckbox" + index
      );
      const counyShowBox: any = this.elem.nativeElement.querySelector(
        "#catCount" + index
      );
      const inputCatCount: any = this.elem.nativeElement.querySelector(
        "#inputCat" + index
      );

      elements.forEach((element) => {
        element.checked = false;
      });

      inputCatCount.value = 0;
      this.categoryCountMap.set(index, 0);
      counyShowBox.textContent = inputCatCount.value;
      this.createFilterJsonObject(elements, "category", false, catName);

      this.cdr.detectChanges();
      const selectBtn = selectAll?.querySelector('button');
      if (selectBtn) {
        selectBtn.focus();
      }
    }
  }

  toggleShowHide(showSelectAll, selectAll, deSelectAll) {
    if (showSelectAll) {
      if (selectAll) {
        this.render.addClass(selectAll, "show");
        this.render.removeClass(selectAll, "hide");
      }
      if (deSelectAll) {
        this.render.addClass(deSelectAll, "hide");
        this.render.removeClass(deSelectAll, "show");
      }
    } else {
      if (selectAll) {
        this.render.addClass(selectAll, "hide");
        this.render.removeClass(selectAll, "show");
      }
      if (deSelectAll) {
        this.render.addClass(deSelectAll, "show");
        this.render.removeClass(deSelectAll, "hide");
      }
    }
  }

  toggleDisplay(element, show) {
    if (show == true) {
      element.add("show");
      element.remove("hide");
    } else {
      element.add("hide");
      element.remove("show");
      element.remove("cq-box-white");
    }
  }

  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (event.target.id != "openMainPanel") {
      if (
        !this.elem.nativeElement.contains(event.target) &&
        this.isFilterOpen == true
      ) {
        this.closeFilter("mainPanel");
      }
    }
  }

  findIndexToBeRemoved(catvalue) {
    var processFilterTest = [];
    this.filterJsonObject.cats = JSON.parse(
      JSON.stringify(this.filterJsonObject.cats)
    );
    if (
      this.filterJsonObject.cats != undefined &&
      this.filterJsonObject.cats.length > 0
    ) {
      this.filterJsonObject.cats.forEach((e) => {
        processFilterTest.push(e.name.toLowerCase() + "#" + e.val);
      });
    }
    return processFilterTest.indexOf(catvalue);
  }
  createFilterJsonObject(elements, section, selectall, catName) {
    let index: any;
    let catvalue: any;
    if (section == "category") {
      elements.forEach((element) => {
        catvalue = catName.toLowerCase() + "#" + element.value;
        index = this.findIndexToBeRemoved(catvalue);
        //index = this.filterJsonObject.cats.indexOf(catName.toLowerCase()+'#'+element.value);
        if (index < 0 && selectall) {
          this.filterJsonObject.cats.push({
            name: catName,
            val: element.value,
          });
        } else if (!selectall) {
          this.filterJsonObject.cats.splice(index, 1);
        }
      });
    } else if (section == "question") {
      elements.forEach((element) => {
        index = this.filterJsonObject.questions.indexOf(
          element.nativeElement.value
        );
        if (index < 0 && selectall) {
          this.filterJsonObject.questions.push(element.nativeElement.value);
        } else if (!selectall) {
          this.filterJsonObject.questions.splice(index, 1);
        }
      });
    }

    this.filterEvent.emit(this.filterJsonObject);
    this.countChangeEvent.emit(this.getCurrentFilterCount());
  }

  onFilterChange(event, itemVal: any, section, filterCatName) {
    let index: any;
    if (section == "category") {
      //index = this.filterJsonObject.cats.indexOf(itemVal);
      let catvalue = filterCatName.toLowerCase() + "#" + itemVal;
      index = this.findIndexToBeRemoved(catvalue);
      if (event.currentTarget.checked) {
        if (index < 0) {
          this.filterJsonObject.cats.push({
            name: filterCatName,
            val: itemVal,
          });
        }
      } else {
        this.filterJsonObject.cats.splice(index, 1);
      }
    } else if (section == "question") {
      index = this.filterJsonObject.questions.indexOf(itemVal);
      if (event.currentTarget.checked) {
        if (index < 0) {
          this.filterJsonObject.questions.push(itemVal);
        }
      } else {
        this.filterJsonObject.questions.splice(index, 1);
      }
      this.questionTypeCheckedMap.set(itemVal, event.currentTarget.checked);
    }
    this.filterEvent.emit(this.filterJsonObject);
    this.countChangeEvent.emit(this.getCurrentFilterCount());
  }

  clearSelection() {
    this.filterJsonObject = { questions: [], cats: [] };
    let catlen = this.questionList.itemInfo.categories.length;
    for (let i = 0; i < catlen; i++) {
      this.deselectAll(
        "category",
        i,
        this.questionList.itemInfo.categories[i].name.toLowerCase()
      );
    }
    this.deselectAll("question", 0, "");
    this.countChangeEvent.emit(this.getCurrentFilterCount());
  }
  private getCurrentFilterCount(): number {
    const questionCount = this.filterJsonObject.questions ? this.filterJsonObject.questions.length : 0;
    const categoryCount = this.filterJsonObject.cats ? this.filterJsonObject.cats.length : 0;
    return questionCount + categoryCount;
  }

  toggleSelection() {
    if (this.selectAllItems) {
      this.selectAll('question', 0, '');
      this.cdr.detectChanges();
      this.deselectButton?.nativeElement.focus();
    } else {
      this.deselectAll('question', 0, '');
      this.cdr.detectChanges();
      this.selectButton?.nativeElement.focus();
    }
  }

  isQuestionTypeChecked(question: string): boolean {
    return this.questionTypeCheckedMap.get(String(question)) || false;
  }
}
